import { render, staticRenderFns } from "./DynamicWorks.vue?vue&type=template&id=0cfda423&scoped=true&"
import script from "./DynamicWorks.vue?vue&type=script&lang=js&"
export * from "./DynamicWorks.vue?vue&type=script&lang=js&"
import style0 from "./DynamicWorks.vue?vue&type=style&index=0&id=0cfda423&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfda423",
  null
  
)

export default component.exports